import * as React from "react"
import { RadioGroup as BaseRadioGroup } from "@base-ui/react/radio-group"
import { Radio as BaseRadio } from "@base-ui/react/radio"
import { cn } from "@lib/cn"

export const RadioGroup = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof BaseRadioGroup>
>(({ className, ...props }, ref) => (
  <BaseRadioGroup ref={ref} className={cn("flex flex-col gap-2", className)} {...props} />
))
RadioGroup.displayName = "RadioGroup"

export interface RadioItemProps
  extends React.ComponentPropsWithoutRef<typeof BaseRadio.Root> {}

export const RadioItem = React.forwardRef<HTMLButtonElement, RadioItemProps>(
  ({ className, ...props }, ref) => (
    <BaseRadio.Root
      ref={ref}
      className={cn(
        "inline-flex size-[18px] shrink-0 items-center justify-center rounded-full border outline-none",
        "border-cloverhound-gray-400 bg-white dark:border-cloverhound-gray-700 dark:bg-cloverhound-gray-900",
        "transition-colors duration-quick ease-out-quad motion-reduce:transition-none",
        "hover:border-cloverhound-gray-600",
        "focus-visible:ring-2 focus-visible:ring-cloverhound-indigo-500 focus-visible:ring-offset-2",
        "focus-visible:ring-offset-cloverhound-gray-50 dark:focus-visible:ring-offset-cloverhound-gray-950",
        "data-[checked]:border-cloverhound-indigo-600",
        "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
        className,
      )}
      {...props}
    >
      <BaseRadio.Indicator className="flex items-center justify-center">
        <span className="size-2 rounded-full bg-cloverhound-indigo-600" />
      </BaseRadio.Indicator>
    </BaseRadio.Root>
  ),
)
RadioItem.displayName = "RadioItem"
